import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'element-ui/lib/theme/index.css'
import '@/assets/css/commont.css'

import 'font-awesome/css/font-awesome.min.css'

import 'amfe-flexible/index'

Vue.use(ElementUI)

//路由管理
router.beforeEach((to, from, next) => {
  //根据字段判断是否路由过滤
  if (to.matched.some(record => record.meta.auth)) {
    if (store.state.access_token !== '') {
      next()
    } else {
      //防止无限循环
      if (to.name === 'Login') {
        next();
        return
      }
      next({
        path: '/',
      });
    }
  } else {
    next() //若点击的是不需要验证的页面,则进行正常的路由跳转
  }
})

Vue.config.productionTip = false
Vue.config.silent = true;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");